import './App.css';
import './services/Axios/Config';
import './utils/DebugWebSocket';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './components/Auth/User';
import { AfiliadosProvider } from './components/Afiliados/AfiliadosProvider';
import { InfoAfiliadoProvider } from './components/Afiliados/InfoAfiliadoProvider';
import InterceptorProvider from './services/Axios/store/InterceptorProvider';
import { SnackbarProvider } from 'notistack';
import VersionControlProvider from './@iosper/components/VersionControl/store/VersionControlProvider';
import { Helmet } from 'react-helmet';
import { Layouts } from './layouts/Layouts';
import ScrollToTop from './components/Common/ScrollToTop';
import { NotificacionesProvider } from './layouts/Header/contexts/NotificacionesContext';

const App = () => {
  return (
    <>
      <Helmet>
        {process.env.REACT_APP_STAGE !== 'production' && (
          <meta name='robots' content='noindex, nofollow' />
        )}
      </Helmet>
      <UserProvider>
        <InterceptorProvider>
          <VersionControlProvider>
            <SnackbarProvider>
              <AfiliadosProvider>
                <InfoAfiliadoProvider>
                  <NotificacionesProvider>
                    {/* <Box> */}
                    <BrowserRouter>
                      <ScrollToTop />
                      <CssBaseline />
                      <Layouts />
                    </BrowserRouter>
                    {/* </Box> */}
                  </NotificacionesProvider>
                </InfoAfiliadoProvider>
              </AfiliadosProvider>
            </SnackbarProvider>
          </VersionControlProvider>
        </InterceptorProvider>
      </UserProvider>
    </>
  );
};
export default App;
